// @flow
import * as React from 'react'
import withFormValidation from '../with_form_validation'
import TextInput, { type Props as TextInputProps } from './TextInput'

const ERROR_TEXT = 'must be a valid email'
const EMAIL_APPROXIMATE_REGEX = /.+@.+\..+/

class EmailTextInput extends React.Component<TextInputProps> {
  render = () => {
    return <TextInput spellCheck={false} {...this.props} type="email" />
  }
}

export default withFormValidation(EmailTextInput, validate)

function validate(val: string) {
  return !EMAIL_APPROXIMATE_REGEX.test(val) ? ERROR_TEXT : undefined
}
